import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ShopColumnFourMain from './ShopColumnFourMain';
import Footer from '../../components/Footer';
import ProductModal from '../../components/Modal/ProductModal';

const ShopColumnFour = () => {
  return (
    <>
      <ProductModal />

      <HeaderSeven />

      <ShopColumnFourMain />

      <Footer />
    </>
  );
};

export default ShopColumnFour;
